export class MenuItemType {
  Label: string;
  Icon: string;
  OverlayIcon: string;
  Color: string;
  Url: any[];
  Type: string; //separator, dropdownMenu, action (default). dropdownMenu currently only supported in Toolbar menu types.
  ObjectCode: string;
  ShowButtonLabel: boolean;
  ShowHyperlinkIcon: boolean;
  Tooltip: string;
  Rules: MenuRuleType[];
  Badge: string;
  Flag: any[];
  DropDownMenuItems: DropDownMenuItemType[]; // Only used when Type = 'dropdownMenu'. Only supported in Toolbar menu types.
}

export class DropDownMenuItemType {
  Label: string;
  Url: any[];
  Rules: MenuRuleType[];
}

export class MenuType {
  objectNode: {
    Menu_Item: [MenuItemType];
  };
}

export enum MenuRuleType {
  DataLoadingSpinner = 'DataLoadingSpinner',
  HighlightIfPageDirty = 'HighlightIfPageDirty',
  Disable = 'Disable',
  DisableIfReadOnlyMode = 'DisableIfReadOnlyMode',
  DisableIfEditMode = 'DisableIfEditMode',
  DisableIfEventInvalid_Delete = 'DisableIfEventInvalid_Delete',
  DisableIfEventInvalid_Update = 'DisableIfEventInvalid_Update',
  Hide = 'Hide',
  HideIfReadOnlyMode = 'HideIfReadOnlyMode',
  HideIfProtectedMode = 'HideIfProtectedMode',
  HideIfEditMode = 'HideIfEditMode',
  HideIfEventInvalid_Submit = 'HideIfEventInvalid_Submit',
  HideIfEventInvalid_Accept = 'HideIfEventInvalid_Accept',
  HideIfEventInvalid_Reject = 'HideIfEventInvalid_Reject',
  HideIfEventInvalid_Void = 'HideIfEventInvalid_Void',
  HideIfEventInvalid_Send = 'HideIfEventInvalid_Send', //Send and Distribute
  HideIfEventInvalid_Delete = 'HideIfEventInvalid_Delete',
  HideIfEventInvalid_Post = 'HideIfEventInvalid_Post',
  HideIfEventInvalid_Update = 'HideIfEventInvalid_Update',
  HideIfEventInvalid_Rate = 'HideIfEventInvalid_Rate',
  HideIfEventInvalid_Approve = 'HideIfEventInvalid_Approve'
  //Add other events here and to action-menu.component
}

export enum MenuLayoutType {
  TileBig = 'TileBig',
  TileSmall = 'TileSmall',
  Sidebar = 'Sidebar',
  Hyperlink = 'Hyperlink',
  Toolbar = 'Toolbar',
  TileText = 'TileText',
  Text = 'Text',
  Unity = 'Unity',
  Cascade = 'Cascade'
}

export enum MenuPositionType {
  Top,
  Left
}
